import type { ReactNode } from "react"

/**
 * The live site's pain-point style: a pale-blue rounded panel with large blue
 * quotation marks at the corners. Used by the event report page and, in
 * English, the home page — the same six statements appear on both.
 */
export function PlaydataSpeechBubble({ children }: { children: ReactNode }) {
  return (
    <li className="relative rounded-[1.2rem] bg-[#dff3fb] px-[2.4rem] py-[1.6rem] text-[1.5rem] leading-[1.6]">
      <span
        aria-hidden="true"
        className="absolute -top-[1rem] -left-[0.4rem] font-play-display text-[3.2rem] text-[var(--color-playdata-blue)] leading-none"
      >
        “
      </span>
      {children}
      <span
        aria-hidden="true"
        className="absolute -right-[0.4rem] -bottom-[2rem] font-play-display text-[3.2rem] text-[var(--color-playdata-blue)] leading-none"
      >
        ”
      </span>
    </li>
  )
}

export function PlaydataSpeechBubbleList({ items }: { items: string[] }) {
  return (
    <ul className="mx-auto grid max-w-[1000px] list-none gap-x-[4rem] gap-y-[3.2rem] p-0 md:grid-cols-2">
      {items.map((item) => (
        <PlaydataSpeechBubble key={item}>{item}</PlaydataSpeechBubble>
      ))}
    </ul>
  )
}

export default PlaydataSpeechBubble
